import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ModalType } from '../modal/modal.enum';
import { Subscription } from 'rxjs';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { DeviceService } from '../../../_services/device.service';
import { SdButtonComponent } from '../../buttons/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { SdTitleComponent } from '../../title/title.component';
import { NgClass } from '@angular/common';
import { SdModalComponent } from '../modal/modal.component';
import { CoreModalService } from '../core-modal/core-modal.service';

@Component({
  selector: 'sd-modal-default',
  templateUrl: './modal-default.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdModalComponent,
    SdTitleComponent,
    SdButtonComponent,
    NgClass,
    TranslateModule
  ],
  providers: [CoreModalService]
})
export class SdModalDefaultComponent implements OnInit, OnDestroy {
  constructor(
    private readonly deviceService: DeviceService,
    private readonly cdRef: ChangeDetectorRef,
  ) {}

  _type = ModalType.modal;
  isMobile$: boolean;
  mobileSubscription: Subscription;

  @Input()
  brand: BrandsEnum;

  /**
   * Title level for the top level title
   */
  @Input()
  modalTitleLevel: number;

  @Input()
  clickToClose = false;

  /**
   * If the title is visible or not
   */
  @Input()
  titleHidden = false;

  /**
   * The title of the modal
   */
  @Input()
  modalTitle: string;

  /**
   * Modal status - disabled or not
   */
  @Input()
  disabled = false;

  /**
   * Modal padding
   */
  @Input()
  noPadding = false;

  /**
   * Manage modal opening/closing
   */
  @Input()
  isOpened = false;

  /**
   * Manage showing close btn text
   */
  @Input()
  showCloseText = false;

  /**
   * Event emitted when the modal is closed or opened
   */
  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  @Output()
  closed = new EventEmitter<void>();

  @Input()
  modalCustomClass = '';

  @Input()
  hasHeader = true;

  @ViewChild('closeModalButton', { read: ElementRef })
  closeModalButton: ElementRef;

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onOpenedChange() {
    this.isOpenedChange.emit(this.isOpened);
  }

  close() {
    this.isOpenedChange.emit(false);
    this.closed.emit();
  }
}
